export const GRAPHQL_URL = window.location.hostname.includes("localhost")
  ? "http://localhost:4003/graphql"
  : "/gravy";
